import React from "react";
import ReactDOM from "react-dom/client";
import "./stylesheets/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Api from "./services/api";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://11c9432c5227c3669d72ca764ec05a79@o113767.ingest.us.sentry.io/4509045462859776"
});
Api.init(store, '');

const root = ReactDOM.createRoot(document.getElementById("o-root"));
root.render(
  // <div style={{margin: 'auto', textAlign: 'center'}}>
  // <p>En mantenimiento</p>
  // </div>
  <React.StrictMode>
    <Provider store={store}> 
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
